module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasAccessRead(_vm.FUNCTIONALITY, [_vm.APPLICATION.CATALOG_FORECAST_ID])) ? _c('section', {
    staticClass: "catalog-forecast-market",
    attrs: {
      "id": "sectionPrincipal"
    }
  }, [(_vm.loading) ? _c('Loader', {
    attrs: {
      "loading": _vm.loading,
      "fixed": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.periodHasZones.length && _vm.periodHasZone) ? [(_vm.props) ? _c("CatalogForecastMarket", _vm._b({
    tag: "component",
    on: {
      "reload": _vm.loadPeriodHasZone,
      "change": _vm.changePeriod,
      "updateIsEdit": _vm.updateIsEdit
    }
  }, 'component', _vm.props, false)) : _vm._e()] : [_c('div', {
    staticClass: "no-period"
  }, [_vm._v(_vm._s(_vm.$t("catalogForecast.market.noPeriod")))])]], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63fd374b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/catalogForcast/pages/CatalogForecastMarketFromDashboard.vue
// module id = 3232
// module chunks = 0